
import {
  defineComponent, ref,
} from 'vue';
import sendNoticeTable from '@/components/Table/index.vue';
import BreadcrumbBlock from '../pubilcComponents/breadcrumbBlock.vue';
import creat from './components/creat.vue';
import detail from './components/detail.vue';
import { Input, } from 'ant-design-vue';
import {
  selectNotice,
} from './sendNotice';
import moment from 'moment';

const { Search, } = Input;

export default defineComponent({
  components: {
    sendNoticeTable,
    BreadcrumbBlock,
    Search,
    creat,
    detail,
  },
  setup (props) {
    const creatVisable = ref(false);
    const detailVisable = ref(false);
    const curTableRow = ref();
    const timeRange = ref(`${moment().format('YYYY-01-01')}~${moment().format('YYYY-MM-DD')}`);
    const pageNum = ref(1);
    const tableData = ref();
    const modalTableData = ref([]);
    const searchData = ref('');
    // 表格行配置
    const columns = ref<any[]>([
      {
        title: '序号',
        width: '6%',
        customRender: (item: any) => `${(pageNum.value - 1) * 10 + item.index + 1}`,
        align: 'center',
      },
      {
        title: '发送对象',
        dataIndex: 'userName',
        key: 'userName',
        align: 'center',
        ellipsis: true,
      },
      {
        title: '通知标题',
        dataIndex: 'title',
        key: 'title',
        align: 'center',
        ellipsis: true,
      },
      {
        title: '通知内容',
        dataIndex: 'content',
        key: 'content',
        align: 'center',
        ellipsis: true,
      },
      {
        title: '发送时间',
        dataIndex: 'createTime',
        key: 'createTime',
        align: 'center',
        width: '10%',
      },
      {
        title: '操作',
        dataIndex: 'op',
        key: 'op',
        align: 'center',
        width: '14%',
        slots: { customRender: 'op', },
      },
    ]);

    const showDetail = (item: any) => {
      if (item) {
        detailVisable.value = true;
        curTableRow.value = item;
      }
    };
    const showCreat = () => {
      creatVisable.value = true;
    };

    const loadTableData = (params: any) => {
      selectNotice(params).then((result: any) => {
        if (result?.code === '200' && result.data.list.length) {
          tableData.value = result.data.list;
        }
      });
    };

    const handleChange = (page: any, pageSize: any) => {
      pageNum.value = page;
      // eslint-disable-next-line no-use-before-define
      pagination.value.current = page;

      const params = {
        name: '',
        pageSize,
        pageNum: page,
      };

      loadTableData(params);
    };

    const onSearch = (searchValue: string) => {
      const params = {
        name: searchValue,
        pageSize: 10,
        pageNum: 1,
      };

      loadTableData(params);
    };

    const pagination = ref({
      total: 0,
      pageSize: 10,
      size: 'small',
      current: pageNum.value,
      showTotal: (total:number) => `共 ${total} 条`,
      onChange: (page: any, pageSize: any) => handleChange(page, pageSize),
    });

    const loadInitData = () => {
      const params = {
        name: '',
        pageSize: 10,
        pageNum: 1,
      };

      selectNotice(params).then((result: any) => {
        if (result?.code === '200' && result.data.list.length) {
          tableData.value = result.data.list;
          pagination.value.total = result.data.total;
        }
      });
    };

    const backToList = () => {
      creatVisable.value = false;
      detailVisable.value = false;
      loadInitData();
    };

    loadInitData();

    return {
      tableData,
      columns,
      creatVisable,
      detailVisable,
      curTableRow,
      timeRange,
      modalTableData,
      pagination,
      searchData,
      showDetail,
      backToList,
      showCreat,
      handleChange,
      onSearch,
      loadTableData,
    };
  },
});
